import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {ProfileFollowModel} from '../views/models/profile-follow.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FollowService {
  follows = new BehaviorSubject<ProfileFollowModel[]>([]);

  constructor(private httpClient: HttpClient) {
  }

  getFollows(profile_id) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/profile_follows/' + profile_id).subscribe(
      (data: ProfileFollowModel[]) => {
        this.follows.next(data);
      }, (err) => {
        console.log(err);
      }
    );
  }
}
